/**
 * Execute callback when running inside an OpenFin or browser environment.
 */
export function whenFin(
    finEnvCallback: () => Promise<any> | any,
    browserEnvCallback?: () => Promise<any> | any
): Promise<any> {
    if (typeof fin !== 'undefined') {
        return finEnvCallback();
    } else {
        return browserEnvCallback?.();
    }
}
